export const CLERK_ENTRY_STORAGE_KEY = 'mythic_clerk_entry';

function getSessionStorage() {
    if (typeof window === 'undefined' || !window.sessionStorage) {
        throw new Error('Clerk entry persistence requires browser sessionStorage.');
    }
    return window.sessionStorage;
}

export function hasClerkEntrySignal(search = window.location.search) {
    const storage = getSessionStorage();
    const hasQueryEntry = new URLSearchParams(search).get('auth') === 'clerk';

    if (hasQueryEntry) {
        storage.setItem(CLERK_ENTRY_STORAGE_KEY, 'true');
        return true;
    }

    return storage.getItem(CLERK_ENTRY_STORAGE_KEY) === 'true';
}

export function clearClerkEntrySignal() {
    getSessionStorage().removeItem(CLERK_ENTRY_STORAGE_KEY);
}
